export default "__VITE_ASSET__D4qJrJ_$__"